import { render, staticRenderFns } from "./Modularization.vue?vue&type=template&id=78a8fabd&"
import script from "./Modularization.vue?vue&type=script&lang=js&"
export * from "./Modularization.vue?vue&type=script&lang=js&"
import style0 from "./Modularization.vue?vue&type=style&index=0&id=78a8fabd&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports